// extracted by mini-css-extract-plugin
module.exports = {"rate":"Rate_rate__30UeI"};